import axiosInstance from './axiosInstance';

// 创建axios实例

const api = axiosInstance;

// 获取所有产品
export const getAllProducts = (language = 'zh') => axiosInstance.get(`/products?lang=${language}`);

// 获取单个产品
export const getProduct = (id, language = 'zh') => axiosInstance.get(`/products/${id}?lang=${language}`);

// 添加产品 - 修改为接受配置参数
export const addProduct = (productData, config) => axiosInstance.post('/products', productData, config);

// 更新产品 - 修改为接受配置参数
export const updateProduct = (id, productData, config) => axiosInstance.put(`/products/${id}`, productData, config);

// 删除产品
export const deleteProduct = (id) => axiosInstance.delete(`/products/${id}`);

// 获取最新产品
// 添加首页产品接口调用
export const getLatestProducts = (language = 'zh') => axiosInstance.get(`/products/latest?lang=${language}`);

// 新增：更新产品组件（热区数据）
export const updateProductComponents = async (productId, componentsData) => {
  // 使用已配置baseURL的api实例，且URL不要重复添加/api前缀
  const response = await axiosInstance.put(`/products/${productId}/components`, componentsData);
  return response.data;
};

export default api;